import { Box } from '#/components/Box/Box';
import { useFormContext } from '#/components/Form/FormContext';
import { InputField } from '#/components/Form/InputField';
import { SubmitButton } from '#/components/Form/SubmitButton/SubmitButton';
import { Label } from '#/components/Label/Label';
import { Switch } from '#/components/Switch/Switch';
import { useI18n } from '#/i18n/hooks/useI18n';
import { spacing } from '#/theme/theme';

export function EditSavedSearchForm() {
  const { i18n } = useI18n();

  const { values, fieldQaIdPrefix, updateValue } = useFormContext<{
    notifyByEmail?: boolean;
  }>();

  return (
    <>
      <Box mb="24px">
        <InputField label={i18n('Name your search')} name="name" noMargin />
      </Box>
      <Box mb="24px" display="flex" gridGap={spacing[12]}>
        <Switch
          id={`${fieldQaIdPrefix}-notify-by-email`}
          qaId={`${fieldQaIdPrefix}-notify-by-email`}
          name="notifyByEmail"
          checked={values.notifyByEmail}
          onChange={(checked) => updateValue('notifyByEmail', checked)}
        />
        <Label htmlFor={`${fieldQaIdPrefix}-notify-by-email`}>
          {i18n('Email Alerts for this search')}
        </Label>
      </Box>
      <SubmitButton fullWidth>{i18n('Update')}</SubmitButton>
    </>
  );
}
